export const CONTACT_TYPE = {
  LABEL: 'label',
  CONTACT: 'contact',
  EXTERNAL: 'external',
  SEARCH: 'search',
  SELECTED: 'selected',
  RECOMMEND: 'recommend',
  ORGANIZATION: 'organization'
};

export const CONTACT_TITLE = {
  [CONTACT_TYPE.CONTACT]: '企业通讯录',
  [CONTACT_TYPE.LABEL]: '标签',
  [CONTACT_TYPE.EXTERNAL]: '外部联系人',
  [CONTACT_TYPE.RECOMMEND]: '常用联系人',
  [CONTACT_TYPE.ORGANIZATION]: '组织架构',
  [CONTACT_TYPE.SEARCH]: '搜索'
};

export const INFO_TITLE = {
  NAME: '用户名',
  REMARK: '备注名',
  LABEL: '标签',
  MOBILE: '手机',
  EMAIL: '邮箱',
  COMPANY: '企业',
  DEPARTMENT: '部门',
  JOB: '职位'
};
